import React from "react";
import { HighLightText } from "../../utils/HighLightText";

interface TagglineProps {
  tagline: string;
  keywords: string[];
}

export const Taggline: React.FC<TagglineProps> = ({ tagline, keywords }) => {
  return (
    <div className="w-full flex justify-between flex-wrap lg:my-4 mt-2 gap-4 lg:text-2xl md:text-lg text-base items-start ">
      <div className="md:w-[24%] w-[45%] capitalize"> {keywords?.[2]} </div>
      <div className="md:w-[24%] w-[45%] capitalize"> {keywords?.[3]} </div>
      <div className="md:w-[48%] w-full lg:text-5xl font-gilroy-bold md:text-3xl text-xl leading-[1]">
        {HighLightText(tagline, "font-gilroy-light")}
      </div>
    </div>
  );
};
